import React from 'react';
import {
  Edit,
  TabbedForm,
  TextInput,
  required,
  ReferenceManyField,
  Datagrid,
  TextField,
  ReferenceField,
  DeleteButton, FormTab,
} from 'react-admin';
import CreateRelatedButton from '../components/CreateRelatedButton';

const GrupoValidacionesEdit = (props) => (
  <Edit mutationMode="optimistic" {...props}>
    <TabbedForm>
      <FormTab label="resources.grupo-validaciones.tabs.general">
        <TextInput source="descripcion" validate={[required()]} label="resources.grupo-validaciones.fields.descripcion"/>
      </FormTab>
      <FormTab label="resources.grupo-validaciones.tabs.prestaciones">
        <CreateRelatedButton
            reference="prestacion-grupo-validaciones"
            refFieldName="idGrupoValidaciones"
            source="id"
            label="resources.grupo-validaciones.buttons.agregarPrestacion"
        />
        <ReferenceManyField
          addLabel={false}
          reference="prestacion-grupo-validaciones"
          source="id"
          target="idGrupoValidaciones"
          sort={{ field: "idPrestacion", order: "DESC" }}
          filter={{ deleted: false }}
        >
          <Datagrid rowClick={null}>
            <TextField source="idPrestacion" label="resources.grupo-validaciones.fields.id"/>
            <ReferenceField
              label="resources.grupo-validaciones.fields.descripcion"
              source="idPrestacion"
              reference="prestaciones"
              link={false}
            >
              <TextField source="descripcion" />
            </ReferenceField>
            <DeleteButton mutationMode="optimistic" redirect={false} />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
    </TabbedForm>
  </Edit>
);

export default GrupoValidacionesEdit;
